import PropTypes from "prop-types";
import { useEffect } from "react";

import { tagular } from "@cohesion/tagular";
import { DESTINATION_PROP_TYPES } from "@constants/places/proptypes";
import { Heading } from "@pageComponents/destinations/heading";

import { Carousel } from "@components/carousel";
import { BasicCard } from "@components/cards/basic";

import { useIntersectionObserver } from "@utils/useIntersectionObserver";

export function RelatedPlaces({ places, ctx }) {
  const { setNodeRef, isVisible } = useIntersectionObserver(
    {
      threshold: 0.5,
    },
    false
  );

  useEffect(() => {
    if (isVisible) {
      tagular("view", {
        webElement: {
          location: "SECTION",
          elementType: "TEXT",
          name: "Related Destinations",
          text: "More destinations you need to see",
        },
      });
    }
  }, [isVisible, ctx.title]);

  if (places.length < 1) return null;

  return (
    <section className="mt-8 lg:mt-16 py-8 bg-sand rounded">
      <div ref={setNodeRef} className="container text-center mt-6 mb-14">
        <Heading>More destinations you need to see</Heading>
      </div>

      <Carousel
        pageSize={5}
        contained={false}
        scrollPadding={false}
        tagularPosition="Related Destinations"
      >
        {places.map((place, i) => (
          <BasicCard
            key={place.esid}
            type="destination"
            href={`/${place.slug}`}
            title={place.title}
            image={place.featuredImage || {}}
            onClick={() =>
              tagular("click", {
                actionOutcome: "internallink",
                outboundUrl: place.slug,
                webElement: {
                  name: "Related Destinations",
                  location: "cards",
                  position: `${i + 1}`,
                  text: place.title,
                  elementType: "link",
                },
              })
            }
          />
        ))}
      </Carousel>
    </section>
  );
}

RelatedPlaces.propTypes = {
  ctx: DESTINATION_PROP_TYPES.ctx, // eslint-disable-line react/require-default-props
  places: PropTypes.arrayOf(
    PropTypes.shape({
      esid: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      featuredImage: PropTypes.shape({
        alt: PropTypes.string,
        caption: PropTypes.string,
        credit: PropTypes.string,
        height: PropTypes.number,
        name: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
        width: PropTypes.number,
      }).isRequired,
    })
  ).isRequired,
};
